import { Vue,Component,Emit,Prop,Watch} from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue'
import Thumbnail from '@/components/Thumbnail/Thumbnail.vue';
import { toCamel } from 'snake-camel';
import moment from "moment";
import store from '@/assets/common/store/store';
import {File} from '@/types/Component';
import { LoginUser} from "@/types/Component";



type Fertilizer = {
    tenantWorkerName: string;
    companyName: string;
    tenantId: string;
    id: string;
    name: string;
    memo: string;
    whereBuy: string;
    maker: string;
    nretio: string;
    kchemRetio: string;
    pretio: string;
    kretio: string;
    mgRetio: string;
    caRetio: string;
    isHidden: boolean;
    isProducer: boolean;
    isDeletable: boolean;
    isEditable: boolean;
    isActive: boolean;
    isProducerFlag: boolean;
    isShippingGroupsFlag: boolean;
    isProducerHidden: boolean;
    imageId: [""];
}

type FertilizersGet = {
    fertilizers: Fertilizer[];
}

type FertilizerGroup = {
  tenantId: string;
  tenantWorkerName: string;
  companyName: string;
  isOpen: boolean;
  fertilizers: Fertilizer[];
};


export type Item = {
    id: string;
    name: string;
    memo: string;
    isActive: boolean;
}


@Component({
    components: {
        Modal,
        Thumbnail
    }
})
export default class FertilizerModal extends Vue {
    
    private list: any | null = null
    private items: any = []
    private title = '肥料'
    private baseUrl = '/fertilizers';
    private clientBaseUrl = '/master/fertilizers'
    private screen = 'FERTILIZERMASTER';
    private selectScreenManagement = '/graphScreenManagement';
    private fertilizers!: Fertilizer[]
    private withHidden = false
    private withProducers = true
    private withShippingOrganization = false
    private isLoading = false
    private headerTitle!: string
    private selectedFertilizer!: Fertilizer
    private fertilizerId = ""
    private fertilizerName = ""
    private fertilizerWhereBuy = ""
    private fertilizerMaker = ""
    private fertilizerMemo = ""
    private nitrogen = ""
    private chemicalComposition = ""
    private phosphate = ""
    private magnesium = ""
    private cali = ""
    private calcium = ""
    private isHidden = false
    private isToggleHidden = false
    private isToggleProducer = true
    private isToggleShippingGroup = true
    private images: File[] = []
    private deletedImages: File[] = []
    private isDeletable = true
    private searchText = ''
    private companyName = ''
    private tenantWorkerName = ''
    private isproducers = false;
    private isEditable = true;
    private selectedItem = "";
    private isToggleProducerAndShippingGroup = false
    private alteredFertilizer = false

    @Prop() 
    isShowFertilizerModal!: boolean

    @Prop()
    isNewFertilizer!: boolean

    @Prop()
    refFertilizerId!: string

    @Watch('isShowFertilizerModal')
    private showFertilizers() {
        if(this.isShowFertilizerModal){
            this.getFertilizers(false)
        }
        if (this.isNewFertilizer) {
            this.createFertilizers(false)
            if (this.refFertilizerId) {
                this.setFertilizers(this.refFertilizerId, false)
            }
        }
    }

    @Watch('isShowFertilizerModal')
    onModalVisibilityChanged(val: boolean) {
        this.$emit('update-inert', val)
    }

    get loginUser(): LoginUser {
    return this.$store.getters.loginUser;
    }

    get pesticidePlanOwner() : boolean {
    return this.loginUser.isPesticidePlan;
    }
    
    get pesticidePlanProducer() : boolean {
    return this.loginUser.pesticidePlanProducer;
    }

    private getFertilizers(withHidden: boolean) {
        this.list = null
        this.isLoading = true
        this.$apiClient.doRequest('get', `${this.baseUrl}?with_hidden=${withHidden}&&with_producer=${this.isToggleProducer}&&with_shipping_organization=${this.isToggleShippingGroup}`).then(ret => {
            this.fertilizers = (toCamel(ret) as FertilizersGet).fertilizers as Fertilizer[]
            if (!this.fertilizers || this.fertilizers.length === 0) {
                this.fertilizers = [];
                this.items =[];
                return;
            }
            const groups: Record<string, FertilizerGroup> = {};
            this.isproducers = this.fertilizers[0].isProducerHidden
            this.isToggleProducer = this.fertilizers[0].isProducerFlag
            this.isToggleShippingGroup = this.fertilizers[0].isShippingGroupsFlag
            if(this.pesticidePlanProducer || this.pesticidePlanOwner){
            if(!this.isToggleProducer && !this.isToggleShippingGroup){
                this.isToggleProducerAndShippingGroup = true
            }else{
                this.isToggleProducerAndShippingGroup = false
            }
            }
            this.fertilizers.forEach(fert => {
                if (!groups[fert.tenantId]) {
                groups[fert.tenantId] = {
                    tenantId: fert.tenantId,
                    tenantWorkerName: fert.tenantWorkerName,
                    companyName: fert.companyName,
                    isOpen: true,
                    fertilizers: [],
                };
                }
                groups[fert.tenantId].fertilizers.push(fert);
            });

            this.items = Object.values(groups);
            this.list = this.items  
            if(this.selectedItem){
              this.isActive(this.selectedItem);
            }
            this.doSearch();         
        })
        .finally(() => {
            this.isLoading = false
        })
    }

    private toggleHiddenItems(value: boolean) {
        this.withHidden = !this.withHidden
        this.getFertilizers(this.withHidden)
    }

    private toggleProducersItems(value: boolean) {
        this.handleSelectChange()
    }

    private toggleShippingGroupItems(value: boolean) {
        this.handleSelectChange()
    }

    private createFertilizers(flag:boolean) {
        this.inputChangedcheck()
        if(this.alteredFertilizer == false){
        this.selectedItem = ""
        this.headerTitle = "新規肥料"
        this.fertilizerId = "create"
        this.fertilizerName = ""
        this.fertilizerWhereBuy = ""
        this.fertilizerMaker = ""
        this.fertilizerMemo = ""
        this.nitrogen = ""
        this.chemicalComposition = ""
        this.phosphate = ""
        this.magnesium = ""
        this.cali = ""
        this.calcium = ""
        this.isHidden = false
        this.images = []
        this.deletedImages = []
        this.isEditable = true
        this.isActive(this.selectedItem);
        if(flag){
            this.openSideBar();
        }
        }
    }

    private setFertilizers(id: string, flag:boolean) {
        const matchedFertilizers: FertilizerGroup[] = this.items.flatMap((item: FertilizerGroup) =>
                item.fertilizers.filter(fertilizer => fertilizer.id === id)
                );
        this.companyName = matchedFertilizers[0]?.companyName || '';
        this.tenantWorkerName = matchedFertilizers[0]?.tenantWorkerName || '';
        this.images = []
        this.headerTitle = this.isNewFertilizer ? "新規肥料": "肥料情報"
        this.inputChangedcheck()
        if(this.alteredFertilizer == false){
            this.selectedItem = id;
            this.$apiClient.doRequest("get", `${this.baseUrl}/${id}`).then((res) => {
                const item = this.selectedFertilizer = toCamel(res) as Fertilizer
                this.fertilizerId = this.isNewFertilizer? "create" : item.id
                this.fertilizerName = item.name
                this.fertilizerMemo = item.memo
                this.fertilizerWhereBuy = item.whereBuy ||""
                this.fertilizerMaker = item.maker || ""
                this.nitrogen = item.nretio
                this.chemicalComposition = item.kchemRetio
                this.phosphate = item.pretio
                this.magnesium = item.mgRetio
                this.cali = item.kretio
                this.calcium = item.caRetio
                this.isHidden = this.isNewFertilizer? false : item.isHidden
                this.isDeletable = item.isDeletable
                this.isEditable = this.isNewFertilizer? true : item.isEditable

                item.imageId.forEach(imi => {
                this.$apiClient.doRequest('get', `${this.baseUrl}/${item.id}/images/${imi}/${item.tenantId}/`).then(res => {
                    const file = toCamel(res) as File
                    this.images.push(file)
                })

            })
            this.deletedImages = []
           })
            if(flag){
                this.openSideBar();
            }
           this.isActive(id);
        }
    }

   private isActive(id: string) {
        this.items?.forEach((item: any) => {
            item.fertilizers?.forEach((fertilizer: any) => {
                fertilizer.isActive = fertilizer.id === id;
            });
        });
    }

    private switchDisplay() {
        if (!window.confirm(`${this.selectedFertilizer.name}を${ this.isHidden ? '表示状態に戻します' : '非表示にします' }。よろしいですか？`)){
            return
        }

        this.isLoading = true

        this.$apiClient.doRequest('put', `${this.baseUrl}/${this.fertilizerId}/display?is_hidden=${!this.isHidden}`).then(() => {
            this.isHidden = !this.isHidden;
            this.getFertilizers(this.withHidden)
            this.$toasted.success(this.isHidden ? '非表示に変更しました。' : '表示に変更しました。');
        })
        .catch(() => {
            this.$toasted.error('変更に失敗しました。')
        })
        .finally(() => {
            this.isLoading = false
        })
    }

    private cancelEdit() {
        if (this.alteredFertilizer) {
         const confirmed = window.confirm("変更内容を破棄します。よろしいですか？");
        if (!confirmed) {
            return;
        }
        }
        this.alteredFertilizer = false;
        if(this.fertilizerId !== 'create') {
            this.setFertilizers(this.fertilizerId, false)
        } else {
            this.createFertilizers(false)
        }
    }

    setItem(id: string, flag:boolean){
        if (id === this.selectedItem) {
            return;
        }
        this.setFertilizers(id,flag);
    }

    private submit(isHiddenUpdate: boolean) {
        const errmsg: string[] = []

        const chem = Number(this.chemicalComposition);
        const nit = Number(this.nitrogen);
        const phos = Number(this.phosphate);
        const mag = Number(this.magnesium);
        const cali = Number(this.cali);
        const cal = Number(this.calcium);
        const values = [nit, phos, mag, cali, cal];
          const total = values .filter(value => !isNaN(value)) .reduce((sum, val) => sum + val, 0);

        

        // 名前の入力
        if(!this.fertilizerName.trim()) {
            errmsg.push("肥料名を入力してください")
        }
        // 名前の長さ
        if(this.fertilizerName.length > 100) {
            errmsg.push(`肥料名は100文字以内で入力してください（現在は${this.fertilizerName.length}文字）`)
        }
        // メモ
        if(this.fertilizerMemo && this.fertilizerMemo.length > 21844) {
            errmsg.push(`メモは21844文字以内で入力してください（現在は${this.fertilizerMemo.length}文字）`)
        }
        //購入先の長さ
        if(this.fertilizerWhereBuy.length > 200) {
            errmsg.push(`購入先名は200文字以内で入力してください（現在は${this.fertilizerWhereBuy.length}文字）`)
        }
        //製造会社の長さ
        if(this.fertilizerMaker.length > 200) {
            errmsg.push(`製造会社名は200文字以内で入力してください（現在は${this.fertilizerMaker.length}文字）`)
        }

        if (nit < chem && nit !== 0) {
            errmsg.push(`化学成分の値が窒素の値を超えています。現在の化学成分の値は ${chem} で、窒素の値は ${nit} です。`);
        }
        if ((chem > 0 && isNaN(nit)) || (chem > 0 && nit === 0)) {
            errmsg.push("窒素(N)を入力してください");
        }
        // if( (nit > 0 && isNaN(chem)) || (nit > 0 && chem === 0)) {
        //     errmsg.push("化学成分を入力してください");
        // }
        if (!isNaN(total) && total > 100) {
            errmsg.push(`成分比の合計（窒素＋リン酸+マグネシウム＋カリ＋カルシウム）が、100%を超えています。`); 
        }
        
        if(this.nitrogen){
            const isMinus: boolean = /-/.test(this.nitrogen.toString())
            const integer: string = this.nitrogen.toString().split('.')[0]
            const decimal: string = this.nitrogen.toString().split('.')[1]
            if(isMinus || integer.length > 3 || decimal && decimal.length > 2){
                errmsg.push("窒素(N)は0以上の整数部3桁小数部2桁までの数値を入力してください。")
            }
        }

        if(errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }
        this.isLoading = true
        const params = {
            name: this.fertilizerName.trim(),
            memo: this.fertilizerMemo,
            whereBuy: this.fertilizerWhereBuy,
            maker: this.fertilizerMaker,
            nitrogen: this.nitrogen || this.nitrogen === '' ? Number(this.nitrogen) || 0 : 0,
            chemicalComposition: this.chemicalComposition || this.chemicalComposition === '' ? Number(this.chemicalComposition) || 0 : 0,
            phosphate: this.phosphate || this.phosphate === '' ? Number(this.phosphate) || 0 : 0,
            cali: this.cali || this.cali === '' ? Number(this.cali) || 0 : 0,
            mgRetio: this.magnesium || this.magnesium === '' ? Number(this.magnesium) || 0 : 0,
            caRetio: this.calcium || this.calcium === '' ? Number(this.calcium) || 0 : 0
        }
        if (this.fertilizerId === "create") {
            this.isLoading = true
            this.$apiClient.doRequest("post", `${this.baseUrl}`, params)
            .then(async res => {
                const promises: Promise<any>[] = []
                // Upload new images
                for (let i = 0; i < this.images.length; i++) {
                    const im = this.images[i];
                  
                    if (im.file) {
                        promises.push(this.$apiClient.fileUpload(`${this.baseUrl}/${res.id}/images/`, im.file))
                    } else if (im.id) {
                        promises.push(this.$apiClient.doRequest(
                            'post',
                            `${this.baseUrl}/${res.id}/images/duplicate?fileId=${im.id}`
                        ));
                    }
                }
                try {
                    await Promise.all(promises);
                    this.getFertilizers(this.withHidden);
                    setTimeout(() => {
                        this.setFertilizers(res.id, false);
                    }, 200);
                    this.$toasted.success('保存しました。');

                    this.images = [];
                    this.deletedImages = [];
                    if (this.isNewFertilizer) {
                        this.$emit('createdFertilizerId', res.id ?? null);
                    }
                } catch {
                    this.$toasted.error('写真の保存に失敗しました。');
                }
            })
            .catch(() => {
                this.$toasted.error('保存に失敗しました。')
            })
            .finally(() => {
                this.isLoading = false
            })
        } else {
            const result = isHiddenUpdate ? true : window.confirm("内容を上書きして保存します。よろしいですか。")
            if(!result) {
                this.isLoading = false
                return false;
            }
            this.$apiClient.doRequest("put", `${this.baseUrl}/${this.fertilizerId}`, params).then(res => {
                const promises: Promise<any>[] = []
                // Upload new images
                this.images.forEach(im => {
                if (im.file) {
                    promises.push(this.$apiClient.fileUpload(`${this.baseUrl}/${res.id}/images/`, im.file))
                }
                })

                // Delete removed images
                this.deletedImages.forEach(im => {
                promises.push(this.$apiClient.doRequest('delete', `${this.baseUrl}/${res.id}/images/${im.id}/`))
                })

                return Promise.all(promises).then(() => {
                    this.getFertilizers(this.withHidden)
                    setTimeout(() => {
                        this.setFertilizers(res.id, false)
                    }, 200);
                    this.$toasted.success('変更を保存しました。')
                    this.images = []
                    this.deletedImages = []
                }).catch(() => {
                    this.$toasted.error('写真の保存に失敗しました。')
                })
            })
            .catch(() => {
                this.$toasted.error('変更に失敗しました。')
            })
            .finally(() => {
                this.isLoading = false
            })
        }
        this.alteredFertilizer = false
        this.searchText = ''

    }

 

    @Emit('inputChanged')
    inputChanged(){
        if(this.alteredFertilizer == false){
            this.alteredFertilizer = true
        }
    }

    @Emit('cancel')
    private cancel() {
        this.isShowFertilizerModal = false
    }

    closeModal(){
        if (this.alteredFertilizer && !window.confirm("変更内容を破棄します。よろしいですか？")) {
        return;
        }
        this.$emit('update:isShowFertilizerModal', false);
        this.fertilizerId = "";
        this.selectedItem = "";
        this.searchText = "";
        this.alteredFertilizer= false
    }

    @Watch('searchText')
    private doSearch() {
    const keyword = this.searchText?.trim() ?? '';
    
    if (!keyword) {
        this.items = this.list;
        return;
    }

    this.items = this.list?.map((group: FertilizerGroup) => {
        const filteredFertilizers = group.fertilizers.filter(f => f.name.includes(keyword));
        return {
        ...group,
        fertilizers: filteredFertilizers
        };
    }).filter((group: FertilizerGroup) => group.fertilizers.length > 0);
    }

    
    openSideBar = () => {
        const isResponsive = window.matchMedia('(max-width: 1000px)').matches;
        if (!isResponsive) {
            return; 
        }
        if(document.body.classList.contains('newsSide')){
            document.body.classList.remove('newsSide')
        }else{
            document.body.classList.add('newsSide')
        }
    }

    // ファイル系
        private onFileChange(e: any) {
            const files = e.target.files || e.dataTransfer.files;
    
            if (this.$apiClient.isSizeOver(files)) {
                return
            }
    
            for (const file of files) {
                if (this.$apiClient.isImageFile(file.name)) {
                    this.$apiClient.getBase64(file).then((image: any) => {
                        const item = {
                            file: image.file,
                            url: image.base64
                        } as File
                        this.images.push(item)
                    }).catch(() => {
                        window.alert('画像ファイルが読み込めませんでした')
                    })
                } else {
                    window.alert('画像ファイルを選択してください')
                }
            }
    
            e.target.value = ''
            this.inputChanged()
        }

    private deleteImage(image: File, index: number) {
        this.images.splice(index, 1)
        if (image.id) {
            this.deletedImages.push(image)
        }
        this.inputChanged()
    }

    private deletedFertilizer(){
        const confirm = window.confirm('削除しますか？')

        this.isLoading = true
        if(confirm) {
            this.$apiClient.doRequest('delete', `${this.baseUrl}/${this.fertilizerId}`)
                .then((response: any) => {
                    if (response) {
                        alert(response);
                        this.isLoading = false;
                        return;
                    }
                    this.$toasted.success('削除しました。')
                    this.getFertilizers(this.withHidden)
                    this.createFertilizers(false);
                })
                .catch(() => {
                    this.$toasted.error('削除に失敗しました。')
                })
        } else {
            this.$toasted.success('削除がキャンセルされました。')
            this.isLoading = false
        }
    }

    inputChangedcheck(){
        if(this.alteredFertilizer==true){
        const confirm = window.confirm('変更内容を破棄します。よろしいですか？')
        if(confirm){
            this.alteredFertilizer = false
        }
        }
    }

    handleSelectChange(flag = true) {
        const params = {
          isProducerFlag: this.isToggleProducer,
          isShippingGroupsFlag: this.isToggleShippingGroup,
          screenName: this.screen,
        }
        this.$apiClient.doRequest('post', `${this.selectScreenManagement}`,params).then(res => {
            if (flag) {
                this.getFertilizers(this.isHidden);
            }
        }).catch(error=>{
            this.$toasted.error('データの取得に失敗しました。')
        })
    } 

    inputValidation(event: InputEvent) {
        const input = event.target as HTMLInputElement;
        const newChar = event.data;
      
        if (!newChar) return;
      
        const selectionStart = input.selectionStart ?? input.value.length;
        const selectionEnd = input.selectionEnd ?? input.value.length;
      
        const nextValue =
          input.value.slice(0, selectionStart) +
          newChar +
          input.value.slice(selectionEnd);
      
        if (nextValue === "" || nextValue === "." || nextValue === "0." || nextValue === "0.0") return;
      
        if (!/^\d{0,3}(\.\d{0,2})?$/.test(nextValue)) {
          event.preventDefault();
          return;
        }
      
        const parsed = parseFloat(nextValue);
      
        if (isNaN(parsed) || parsed > 100) {
          event.preventDefault();
        }
    }
      
    }
